var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"code-area"},[_vm._v("  "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }